import React from "react";
import {
  DurationMinutesRangeFilterInput,
  DurationPctRangeFilterInput,
} from "./components/DurationMinutesRangeFilterInput";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../../constants/ZoomAttendance.constants";
import {
  getUnrecognizedColumnsConfig,
  getStandardColumnsConfig,
} from "./components/getParticipantColumnsConfig";

export const getSessionParticipantsColumnConfig = ({
  onReconcileClick,
  onViewReportClick,
  onMapToBooking,
  onCreateNewBooking,
  isUnrecognizedView = false,
}) => {
  if (isUnrecognizedView) {
    return getUnrecognizedColumnsConfig({
      onReconcileClick,
      onMapToBooking,
      onCreateNewBooking,
    });
  }

  return getStandardColumnsConfig({
    onReconcileClick,
    onViewReportClick,
    onMapToBooking,
    onCreateNewBooking,
  });
};

export const getTabFilterConfig = ({
  unrecognizedCount = ZOOM_ATTENDANCE_CONSTANTS.NUMERIC.ZERO,
} = {}) => [
  {
    label: ZOOM_ATTENDANCE_CONSTANTS.LABELS.FULL_ATTENDANCE_TAB,
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.ATTENDANCE_TYPE,
    filterValue:
      ZOOM_ATTENDANCE_CONSTANTS.PARTICIPANT_ATTENDANCE_TYPES.FULL_ATTENDANCE,
    value: ZOOM_ATTENDANCE_CONSTANTS.TAB_VALUES.FULL,
  },
  {
    label: ZOOM_ATTENDANCE_CONSTANTS.LABELS.PARTIAL_ATTENDANCE_TAB,
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.ATTENDANCE_TYPE,
    filterValue:
      ZOOM_ATTENDANCE_CONSTANTS.PARTICIPANT_ATTENDANCE_TYPES.PARTIAL_ATTENDANCE,
    value: ZOOM_ATTENDANCE_CONSTANTS.TAB_VALUES.PARTIAL,
  },
  {
    label: ZOOM_ATTENDANCE_CONSTANTS.LABELS.NO_ATTENDANCE_TAB,
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.ATTENDANCE_TYPE,
    filterValue:
      ZOOM_ATTENDANCE_CONSTANTS.PARTICIPANT_ATTENDANCE_TYPES.NO_ATTENDANCE,
    value: ZOOM_ATTENDANCE_CONSTANTS.TAB_VALUES.NO,
  },
  {
    label: (
      <span className="tw-inline-flex tw-items-center tw-gap-1.5">
        {ZOOM_ATTENDANCE_CONSTANTS.LABELS.UNRECOGNIZED_ATTENDEES_TAB}
        {unrecognizedCount >= ZOOM_ATTENDANCE_CONSTANTS.NUMERIC.ZERO && (
          <span className="tw-bg-amber-100 tw-text-amber-800 tw-text-xs tw-font-bold tw-px-1.5 tw-py-0.5 tw-rounded-full">
            {unrecognizedCount}
          </span>
        )}
      </span>
    ),
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.ATTENDANCE_TYPE,
    filterValue:
      ZOOM_ATTENDANCE_CONSTANTS.PARTICIPANT_ATTENDANCE_TYPES.UNRECOGNIZED,
    value: ZOOM_ATTENDANCE_CONSTANTS.TAB_VALUES.UNRECOGNIZED,
  },
];

const renderDurationFilter = (props) => (
  <DurationMinutesRangeFilterInput {...props} />
);

const renderDurationPctFilter = (props) => (
  <DurationPctRangeFilterInput {...props} />
);

export const filterConfig = [
  {
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_NAME,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.LABELS.NAME,
    type: "input",
    disableContains: true,
  },
  {
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_EMAIL,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.LABELS.EMAIL,
    type: "input",
    disableContains: true,
  },
  {
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_PHONE,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.LABELS.PHONE_NUMBER,
    type: "input",
    disableContains: true,
  },
  {
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.DURATION_RANGE,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.LABELS.DURATION_MINS_PLACEHOLDER,
    type: "custom",
    render: renderDurationFilter,
    renderFilter: renderDurationFilter,
  },
  {
    source: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.DURATION_PCT_RANGE,
    placeholder: ZOOM_ATTENDANCE_CONSTANTS.LABELS.DURATION_PCT_PLACEHOLDER,
    type: "custom",
    render: renderDurationPctFilter,
    renderFilter: renderDurationPctFilter,
  },
];

export const tableChipsFormatter = (
  filter,
  value,
  selectedFilter,
  filterValues = {}
) => {
  if (filter === ZOOM_ATTENDANCE_CONSTANTS.FIELDS.ATTENDANCE_TYPE) {
    return null;
  }
  if (
    filter === ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_NAME ||
    filter === ZOOM_ATTENDANCE_CONSTANTS.FIELDS.NAME
  ) {
    return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.NAME}: ${value}`;
  }
  if (
    filter === ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_EMAIL ||
    filter === ZOOM_ATTENDANCE_CONSTANTS.FIELDS.USER_EMAIL
  ) {
    return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.EMAIL}: ${value}`;
  }
  if (filter === ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_PHONE) {
    return `${ZOOM_ATTENDANCE_CONSTANTS.LABELS.PHONE}: ${value}`;
  }
  if (filter === ZOOM_ATTENDANCE_CONSTANTS.FIELDS.MINUTES_TO) {
    return null;
  }
  if (filter === ZOOM_ATTENDANCE_CONSTANTS.FIELDS.MINUTES_FROM) {
    const from = filterValues.minutes_from;
    const to = filterValues.minutes_to;
    if (
      from !== undefined &&
      from !== null &&
      to !== undefined &&
      to !== null
    ) {
      return `Duration (mins): From ${from} - to ${to}`;
    }
    if (from !== undefined && from !== null) {
      return `Duration (mins): From ${from}`;
    }
    if (to !== undefined && to !== null) {
      return `Duration (mins): To ${to}`;
    }
  }
  if (filter === ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_TO) {
    const from = filterValues.attendance_from;
    if (from !== undefined && from !== null && from !== "") {
      return null;
    }
    return `Duration (%): To ${value}`;
  }
  if (filter === ZOOM_ATTENDANCE_CONSTANTS.FILTERS.SOURCE_ATTENDANCE_FROM) {
    const from = filterValues.attendance_from;
    const to = filterValues.attendance_to;
    if (
      from !== undefined &&
      from !== null &&
      to !== undefined &&
      to !== null &&
      to !== ""
    ) {
      return `Duration (%): From ${from} - to ${to}`;
    }
    if (from !== undefined && from !== null && from !== "") {
      return `Duration (%): From ${from}`;
    }
    if (to !== undefined && to !== null && to !== "") {
      return `Duration (%): To ${to}`;
    }
  }
  return `${filter}: ${value}`;
};
